module.exports = __webpack_public_path__ + "media/images/add_rounded-e348390aa9715db9519c56e778992879.svg";